import { useEffect, useState } from "react";
import axios from "axios";
import { useDataContext } from "../Context/dataContext";

function useFetchTotal(accessToken) {
  const { url } = useDataContext();
  const [totalEur, setTotalEur] = useState(null);
  const [totalUsd, setTotalUsd] = useState(null);
  const [totalGbp, setTotalGbp] = useState(null);
  const [totalUsers, setTotalUsers] = useState(null);
  const [totalUsersV, setTotalUsersV] = useState(null);
  const [totalUsersR, setTotalUsersR] = useState(null);
  const [totalUsersP, setTotalUsersP] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!accessToken || !url) return;
    setLoading(true);
    setError(null);

    const now = new Date();
    const formattedDate = `${now.getFullYear()}-${(now.getMonth() + 1)
      .toString()
      .padStart(2, "0")}-${now.getDate().toString().padStart(2, "0")}`;

    const fetchTotals = async () => {
      try {
        const headers = { Authorization: `Bearer ${accessToken}` };

        const [eurRes, usdRes, gbpRes, users] = await Promise.all([
          axios.get(`${url}/Movements/totaleur/${formattedDate}`, { headers }),
          axios.get(`${url}/Movements/totalusd/${formattedDate}`, { headers }),
          axios.get(`${url}/Movements/totalgbp/${formattedDate}`, { headers }),
          axios.get(`${url}/users`, { headers }),
        ]);

        const allUsers = users.data;
        const verifiedUsers = allUsers.filter((user) => user.use_verif === "S");
        const pendingUsers = allUsers.filter((user) => user.use_verif === "E");
        const rejectedUsers = allUsers.filter((user) => user.use_verif === "N");

        setTotalEur(eurRes.data);
        setTotalUsd(usdRes.data);
        setTotalGbp(gbpRes.data);
        setTotalUsers(allUsers.length);
        setTotalUsersV(verifiedUsers.length);
        setTotalUsersR(rejectedUsers.length);
        setTotalUsersP(pendingUsers.length);
      } catch (error) {
        setError(error);
      } finally {
        setLoading(false);
      }
    };

    fetchTotals();
  }, [accessToken, url]);

  return { totalEur, totalUsd, totalGbp, totalUsers, totalUsersV, totalUsersR, totalUsersP, loading, error };
}

export { useFetchTotal };
